import { render, staticRenderFns } from "./BenefitsContainer.vue?vue&type=template&id=5334715e&scoped=true&"
import script from "./BenefitsContainer.vue?vue&type=script&lang=js&"
export * from "./BenefitsContainer.vue?vue&type=script&lang=js&"
import style0 from "./BenefitsContainer.vue?vue&type=style&index=0&id=5334715e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5334715e",
  null
  
)

export default component.exports